export const invoicesRoutePath = '/settings/account/billing/invoices/:invoiceId';
